export const medicalServiceConstants = {
    SUCCESS: 'MEDICAL_SERVICE_SUCCESS',
    SUCCESS_ADMIN: 'MEDICAL_SERVICE_ADMIN_SUCCESS',
    ERROR: 'MEDICAL_SERVICE_ERROR',
    FETCHING: 'MEDICAL_SERVICE_FETCHING',
    FETCHING_ADMIN: 'MEDICAL_SERVICE_ADMIN_FETCHING',
};
